@if (visible()) {
<div class="fixed z-50 bg-white border border-gray-300 rounded-md shadow-lg"
     [style.left.px]="position().x"
     [style.top.px]="position().y">
  <div class="w-48">
    <div class="px-4 py-2 bg-gray-700 text-white text-sm font-medium rounded-t-md">
      Sélectionnez une action
    </div>

    <div class="py-1">
      @for (item of menuItems(); track item.itemKey) {
      <div class="px-4 py-2 hover:bg-blue-100 cursor-pointer"
                  [class.opacity-50]="item.disabled"
            [class.pointer-events-none]="item.disabled"
            (click)="!item.disabled && item.action()"
        >
        {{ item.itemText }}
      </div>

      @if (!$last) {
      <div class="border-t border-gray-300"></div>
      }
      }
    </div>

    <div class="border-t border-gray-300"></div>
    <div class="px-4 py-2 bg-gray-400 hover:bg-gray-500 cursor-pointer"
         (click)="visible.set(false)">
      Cacher
    </div>
  </div>
</div>
}
